"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserStatsNotFoundError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for when no user stats are found with a given user id
 */
class UserStatsNotFoundError extends client_library_1.ExtendableError {
    constructor() {
        super(`no user stats exist for the given user id`);
    }
}
exports.UserStatsNotFoundError = UserStatsNotFoundError;
//# sourceMappingURL=UserStatsNotFoundError.js.map